<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Disponibilidad</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>

        <div>
          <base-input v-model="searchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"></base-input>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
        <el-table-column label="Código" min-width="180px" prop="code" sortable> </el-table-column>

        <el-table-column label="Descripción" min-width="180px" prop="description" sortable> </el-table-column>

        <el-table-column label="Cultivo" min-width="120px" prop="variety">
          <template #default="{ row }">
            <div v-if="row.variety">{{ row.variety.name }}</div>
            <small v-if="row.variety && row.variety.crop">{{ row.variety.crop.name }}</small>
          </template>
        </el-table-column>

        <el-table-column label="Campaña" min-width="120px" prop="campaign">
          <template #default="{ row }">
            <div v-if="row.campaign">{{ row.campaign.name }}</div>
          </template>
        </el-table-column>

        <el-table-column v-if="authorized" label="Cantidad Total" min-width="120px" prop="stock">
          <template #default="{ row }">
            <div v-if="row.stock">{{ row.stock }}</div>
          </template>
        </el-table-column>

        <el-table-column v-if="authorized" label="Pedidos" min-width="120px" prop="stock">
          <template #default="{ row }">
            <div v-if="row.stock">{{ row.unitsInOrders }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Cantidad Disponible" min-width="120px" prop="stock">
          <template #default="{ row }">
            <div v-if="row.stock">{{ row.availability }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ total }} artículos</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        class="pagination-no-border"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';
import DeleteRowFromTableMixin from '../../../mixins/deleteRowFromTableMixin';
import { isSeller, isDistributor } from '@/util/roles';

export default {
  name: 'AvailabilityTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationMixin, DeleteRowFromTableMixin],
  props: ['campaign'],
  data() {
    return {
      searchKeys: ['code', 'description', 'variety.name', 'variety.crop.name', 'campaign.name'],
      tableData: [],
      tableName: 'ArticlesTable',
    };
  },

  computed: {
    authorized() {
      return !(isSeller(this.$auth.user()) || isDistributor(this.$auth.user()));
    },
  },

  created() {
    // configuracion para el alert de eliminar
    this.alertSettings.title = 'Se eliminará el artículo';
    this.alertSuccessSettings.message = 'El artículo ha sido eliminado';
    this.resourceName = 'articles';
  },

  mounted() {
    this.$services
      .resource('articles')
      .get({ sort: 'description', 'filter[campaign]': this.campaign.id, include: ['variety.crop', 'campaign.crops'] })
      .then((res) => res.data.data)
      .then((data) => (this.tableData = data.articles));
  },
};
</script>
